var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76382 9.42468L6.30811 9.77868L6.65873 7.30334L12.974 0.939343C13.2531 0.658036 13.6317 0.5 14.0265 0.5C14.222 0.5 14.4156 0.538799 14.5962 0.614181C14.7768 0.689564 14.9408 0.800054 15.0791 0.939343C15.2173 1.07863 15.3269 1.24399 15.4017 1.42598C15.4765 1.60797 15.515 1.80303 15.515 2.00001C15.515 2.19699 15.4765 2.39205 15.4017 2.57404C15.3269 2.75603 15.2173 2.92139 15.0791 3.06068L8.76382 9.42468Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.272 1.64844L14.3771 3.76977",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.538 9.5V14.5C12.538 14.7652 12.4334 15.0196 12.2473 15.2071C12.0612 15.3946 11.8088 15.5 11.5456 15.5H1.62222C1.35904 15.5 1.10663 15.3946 0.920533 15.2071C0.734433 15.0196 0.629883 14.7652 0.629883 14.5V4.5C0.629883 4.23478 0.734433 3.98043 0.920533 3.79289C1.10663 3.60536 1.35904 3.5 1.62222 3.5H6.58393",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.e5463f45.svg";
export { ForwardRef as ReactComponent };